module.exports = __webpack_public_path__ + "static/img/pic_jizhengbm@2x.5ca0e06d.png";